import { json } from 'aurelia-fetch-client';
import { autoinject, computedFrom } from 'aurelia-framework';
import { ApiService } from '../../../utils/api-service';

@autoinject
export class AccountImportService {
	rawAccountData: string;

	constructor(private http: ApiService) {
	}

	cleanAccountData(): AccountData[] {
		if (!this.rawAccountData) { return []; }

		return this.rawAccountData.split('\n')
			.filter(item => item.length > 0)
			.map((item) => {
				const accountSegments = item.split('\t');
				return new AccountData(
					parseInt(accountSegments[0], 10),
					accountSegments[1],
					accountSegments.length > 2 ? accountSegments[2] : null,
					accountSegments.length > 3 ? accountSegments[3].split(',').map(tag => tag.trim()) : []
				);
			});
	}

	submitData(accountData: AccountData[], accountChartId: string): Promise<Response> {
		return this.http.fetch('account-charts/' + accountChartId + '/import', {
			method: 'post',
			body: json(accountData)
		});
	}
}

export class AccountData {
	number: number;
	name: string;
	accountGroupSpecifier: string;
	tags: string[];

	constructor(accountNumber: number, accountName: string, accountGroupSpecifier: string, tags: string[]) {
		this.number = accountNumber;
		this.name = accountName;
		this.accountGroupSpecifier = accountGroupSpecifier;
		this.tags = tags;
	}

	@computedFrom('tags')
	get tagCodes() {
		return this.tags.join(', ');
	}
}
